import _toConsumableArray from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _createForOfIteratorHelper from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _regeneratorRuntime from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import axios from 'axios';
import dayjs from 'dayjs';
import * as echarts from 'echarts';
import chinaGeoJSON from '@/assets/china-border.json';
import xinjiangGeoJSON from '@/assets/xinjiang-border.json';
export default {
  data: function data() {
    return {
      dayjs: dayjs,
      queryLoading: false,
      productName: '',
      sourceBatchList: [],
      sourceBatchData: {},
      qrCode: ''
    };
  },
  watch: {
    productName: function productName() {
      this.getSourceBatch();
    }
  },
  mounted: function mounted() {
    this.getSourceBatch();
    this.getScanReport();
    this.getScanReocrd();
  },
  methods: {
    getSourceBatch: function getSourceBatch() {
      var _this = this;
      //溯源批次列表
      this.$api['sourceBatchQuery']({
        productName: this.productName,
        page: 1,
        limit: 10,
        sortField: 'create_time',
        labId: localStorage.getItem('labId')
      }).then(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(res) {
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _this.sourceBatchList = res.data || [];
                _this.sourceBatchData = res.data.length ? res.data[0] : {};
                _context.next = 4;
                return _this.getQrcode();
              case 4:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    sourceBatchClick: function sourceBatchClick(val) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this2.taskList = [];
              _this2.itemList = [];
              _this2.qrCode = '';
              _this2.sourceBatchData = JSON.parse(JSON.stringify(val));
              _context2.next = 6;
              return _this2.getScanReocrd();
            case 6:
              _context2.next = 8;
              return _this2.getQrcode();
            case 8:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    backClick: function backClick() {
      this.$router.back();
    },
    getQrcode: function getQrcode() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var res;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return axios({
                url: "".concat(process.env.VUE_APP_API, "/wechat/applet/minicode/").concat(_this3.sourceBatchData.id),
                method: 'GET',
                params: {
                  page: "src/pagesA/source/traceCode"
                },
                headers: {
                  'Content-Type': 'application/json;charset=UTF-8',
                  'Authorization': localStorage.getItem('token')
                },
                responseType: 'blob' // 关键！
              });
            case 2:
              res = _context3.sent;
              _this3.qrCode = URL.createObjectURL(res.data);
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    initMap: function initMap(data) {
      if (this.map) {
        try {
          this.map.destroy();
        } catch (e) {}
        this.map = null;
        document.getElementById('map').innerHTML = '';
      }
      // 核心：先声明 T = window.T
      var T = window.T;
      // 创建地图实例
      this.map = new T.Map("map");
      // 设置中心点和缩放级别
      this.map.centerAndZoom(new T.LngLat(104.0, 35.0), 4);

      // // 1. 添加标准底图（例如：矢量底图）
      // // 注意：矢量底图是必须的，它是地图的“皮肤”
      // const baseLayer = new T.TileLayer(
      //     'http://t0.tianditu.gov.cn/vec_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=vec&STYLE=default&FORMAT=tiles&TILEMATRIXSET=w&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=9987072a4193b993c432efa0734c3aed'
      // );
      // this.map.addLayer(baseLayer);

      // // 2. 叠加“境界注记图层”，让国界线更突出
      // // 这是专门用来显示国界、省界的图层
      // const boundaryLayer = new T.TileLayer(
      //     'http://t0.tianditu.gov.cn/ibo_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=ibo&STYLE=default&FORMAT=tiles&TILEMATRIXSET=w&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=9987072a4193b993c432efa0734c3aed'
      // );
      // this.map.addLayer(boundaryLayer);

      // GeoJSON 并绘制中国国界
      this.drawChinaBoundary();

      // // 2. 定义可切换的地图类型列表
      // let mapTypeList = [
      //     {
      //         title: '卫星混合',
      //         icon: 'http://api.tianditu.gov.cn/v4.0/image/map/maptype/satellitepoi.png',
      //         layer: TMAP_HYBRID_MAP
      //     },
      //     {
      //         title: '地图',
      //         icon: 'http://api.tianditu.gov.cn/v4.0/image/map/maptype/vector.png',
      //         layer: TMAP_NORMAL_MAP // 注意：这个全局变量需要是 window.TMAP_NORMAL_MAP
      //     },
      //     {
      //         title: '地形',
      //         icon: 'http://api.tianditu.gov.cn/v4.0/image/map/maptype/terrain.png',
      //         layer: TMAP_TERRAIN_MAP
      //     }
      // // 可以继续添加更多类型，如 TMAP_SATELLITE_MAP (纯卫星图) 等 [citation:2][citation:12]
      // ];

      // // 3. 创建地图类型控件并添加到地图
      // let mapTypeControl = new T.Control.MapType(mapTypeList);
      // this.map.addControl(mapTypeControl);

      // 卫星地图样式
      this.map.setMapType(window.TMAP_SATELLITE_MAP);

      // 添加标记等操作...
      var marker;
      var _iterator = _createForOfIteratorHelper(data),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          marker = new T.Marker(new T.LngLat(item.scanLng, item.scanLat));
          this.map.addOverLay(marker);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    },
    initMap1: function initMap1(data) {
      var _this4 = this;
      if (this.map) {
        try {
          this.map.destroy();
        } catch (e) {}
        this.map = null;
        document.getElementById('map').innerHTML = '';
      }
      var T = window.T;

      // 1. 创建地图实例
      this.map = new T.Map("map");
      this.map.centerAndZoom(new T.LngLat(104.0, 35.0), 4);

      // 2. 添加卫星底图（用 TileLayer，而不是 setMapType）
      // 因为 setMapType 可能与热力图覆盖物冲突
      var satelliteLayer = new T.TileLayer('http://t0.tianditu.gov.cn/img_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=img&STYLE=default&FORMAT=tiles&TILEMATRIXSET=w&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=9987072a4193b993c432efa0734c3aed');
      this.map.addLayer(satelliteLayer);

      // 3. 添加影像标注图层（地名、路名）
      var labelLayer = new T.TileLayer('http://t0.tianditu.gov.cn/cia_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=cia&STYLE=default&FORMAT=tiles&TILEMATRIXSET=w&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=9987072a4193b993c432efa0734c3aed');
      this.map.addLayer(labelLayer);

      // 4. 绘制国界线（放在最上层）
      this.drawChinaBoundary();

      // 6. 添加标记（放在最上层）
      if (data && data.length > 0) {
        var _iterator2 = _createForOfIteratorHelper(data),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var item = _step2.value;
            var marker = new T.Marker(new T.LngLat(item.scanLng, item.scanLat));
            this.map.addOverLay(marker);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
      // 5. 创建热力图（放在国界线下面）
      var points = [{
        lng: 116.404,
        lat: 39.915,
        count: 100
      }, {
        lng: 121.464,
        lat: 31.241,
        count: 200
      }, {
        lng: 113.264,
        lat: 23.129,
        count: 150
      }, {
        lng: 106.551,
        lat: 29.563,
        count: 80
      }, {
        lng: 114.057,
        lat: 22.543,
        count: 120
      }, {
        lng: 118.767,
        lat: 32.041,
        count: 90
      }, {
        lng: 112.549,
        lat: 37.857,
        count: 60
      }, {
        lng: 120.153,
        lat: 30.287,
        count: 180
      }, {
        lng: 108.940,
        lat: 34.341,
        count: 140
      }, {
        lng: 114.298,
        lat: 30.584,
        count: 110
      }];
      this.$nextTick(function () {
        _this4.createHeatmap(points);
      });
    },
    createHeatmap: function createHeatmap(points) {
      var _this5 = this;
      var T = window.T;
      if (typeof T.HeatmapOverlay !== 'function') {
        console.error('T.HeatmapOverlay 未加载');
        return;
      }
      if (!this.map) {
        console.error('地图实例不存在');
        return;
      }
      if (!points || points.length === 0) {
        console.warn('热力图数据为空');
        return;
      }

      // 确保地图完全加载
      var _ensureMapReady = function ensureMapReady() {
        var retryCount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        try {
          var bounds = _this5.map.getBounds();
          if (bounds) {
            console.log('地图边界获取成功，开始创建热力图');
            _this5._createHeatmapInternal(points);
            return;
          }
        } catch (e) {
          console.warn("\u83B7\u53D6\u5730\u56FE\u8FB9\u754C\u5931\u8D25 (\u5C1D\u8BD5 ".concat(retryCount + 1, "):"), e.message);
        }
        if (retryCount < 5) {
          setTimeout(function () {
            _ensureMapReady(retryCount + 1);
          }, 500);
        } else {
          console.error('地图加载超时，无法创建热力图');
        }
      };
      _ensureMapReady();
    },
    _createHeatmapInternal: function _createHeatmapInternal(points) {
      var _this6 = this;
      try {
        // 移除旧热力图
        if (this.heatmapOverlay) {
          try {
            this.map.removeOverLay(this.heatmapOverlay);
          } catch (e) {
            console.warn('移除旧热力图失败:', e);
          }
          this.heatmapOverlay = null;
        }
        var config = {
          radius: 40,
          gradient: {
            0.2: 'blue',
            0.4: 'cyan',
            0.6: 'lime',
            0.8: 'yellow',
            1.0: 'red'
          }
        };

        // 创建热力图
        try {
          // 尝试传入map实例
          this.heatmapOverlay = new T.HeatmapOverlay(this.map, config);
        } catch (e) {
          // 如果不支持传入map，则不传
          this.heatmapOverlay = new T.HeatmapOverlay(config);
        }

        // 先添加到地图
        this.map.addOverLay(this.heatmapOverlay);

        // 准备数据
        var heatmapData = {
          data: points.map(function (item) {
            return {
              lng: parseFloat(item.lng),
              lat: parseFloat(item.lat),
              count: parseFloat(item.count) || 1
            };
          }),
          max: Math.max.apply(Math, _toConsumableArray(points.map(function (p) {
            return p.count;
          })).concat([300]))
        };

        // 使用requestAnimationFrame确保DOM更新
        requestAnimationFrame(function () {
          setTimeout(function () {
            try {
              _this6.heatmapOverlay.setDataSet(heatmapData);
              console.log('✅ 热力图绘制成功，数据点数量:', points.length);
            } catch (error) {
              console.error('❌ 设置热力图数据失败:', error);
              // 最后的补救方案
              _this6._fallbackHeatmap(points);
            }
          }, 100);
        });
      } catch (error) {
        console.error('❌ 热力图创建失败:', error);
        this._fallbackHeatmap(points);
      }
    },
    // 备用方案：使用简化版热力图
    _fallbackHeatmap: function _fallbackHeatmap(points) {
      console.warn('使用备用方案绘制热力图');
      try {
        // 尝试重新创建，不传任何额外参数
        this.heatmapOverlay = new window.T.HeatmapOverlay({
          radius: 40,
          gradient: {
            0.2: 'blue',
            0.4: 'cyan',
            0.6: 'lime',
            0.8: 'yellow',
            1.0: 'red'
          }
        });
        var heatmapData = {
          data: points.map(function (item) {
            return {
              lng: parseFloat(item.lng),
              lat: parseFloat(item.lat),
              count: parseFloat(item.count) || 1
            };
          }),
          max: Math.max.apply(Math, _toConsumableArray(points.map(function (p) {
            return p.count;
          })).concat([300]))
        };
        this.heatmapOverlay.setDataSet(heatmapData);
        this.map.addOverLay(this.heatmapOverlay);
        console.log('✅ 备用方案成功');
      } catch (error) {
        console.error('❌ 备用方案也失败了:', error);
      }
    },
    getScanReocrd: function getScanReocrd() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var res;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return _this7.$api['scanReocrdQuery']({
                labId: localStorage.getItem('labId'),
                page: 1,
                limit: -1,
                sortField: 'create_time'
              });
            case 2:
              res = _context4.sent;
              _context4.next = 5;
              return _this7.$nextTick(function () {
                _this7.initMap(res.data);
              });
            case 5:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    getScanReport: function getScanReport() {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var res, data, _iterator3, _step3, item, chartDom, myChart, option;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return _this8.$api['scanReocrdReport'](localStorage.getItem('labId'));
            case 2:
              res = _context5.sent;
              data = [];
              _iterator3 = _createForOfIteratorHelper(res.data);
              try {
                for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                  item = _step3.value;
                  data.push({
                    value: item.indicator,
                    name: item.latitude
                  });
                }
              } catch (err) {
                _iterator3.e(err);
              } finally {
                _iterator3.f();
              }
              chartDom = document.getElementById('chartDom');
              myChart = echarts.init(chartDom);
              option = {
                tooltip: {
                  trigger: 'item'
                },
                legend: {
                  orient: 'vertical',
                  left: 'left',
                  top: 'bottom',
                  textStyle: {
                    color: '#ffffff'
                  }
                },
                series: [{
                  name: '批次扫码量',
                  type: 'pie',
                  radius: '50%',
                  data: data,
                  color: ['#FADB67',
                  // 明黄
                  '#FF9F7C',
                  // 珊瑚橙
                  '#FB7293',
                  // 粉红
                  '#67E0E3',
                  // 青蓝
                  '#6F9BFF',
                  // 亮蓝
                  '#B47CFF',
                  // 浅紫
                  '#7EE0A0',
                  // 亮绿
                  '#FFB6C1' // 浅粉
                  ],
                  emphasis: {
                    itemStyle: {
                      shadowBlur: 10,
                      shadowOffsetX: 0,
                      shadowColor: 'rgba(255, 255, 255, 0.3)' // 高亮阴影调亮
                    }
                  },
                  label: {
                    show: false
                  }
                }]
              };
              option && myChart.setOption(option);
            case 10:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    drawChinaBoundary: function drawChinaBoundary() {
      var _this9 = this;
      var T = window.T;

      // 从 GeoJSON 中提取所有坐标点
      var allCoordinates = this.extractAllCoordinates(chinaGeoJSON);
      //   const allCoordinates = this.extractAllCoordinates(xinjiangGeoJSON);

      // 如果数据太大，可以只绘制前几个省份来测试
      // 这里绘制所有省份
      allCoordinates.forEach(function (coords) {
        // 将坐标数组转换为 T.LngLat 对象数组
        var points = coords.map(function (coord) {
          return new T.LngLat(coord[0], coord[1]);
        });

        // 创建多边形覆盖物（带填充和边框）
        var polygon = new T.Polygon(points, {
          color: '#FFD700',
          // 边框颜色
          weight: 2,
          // 边框宽度
          opacity: 0.8,
          fillColor: 'rgba(255, 215, 0, 0.1)',
          // 半透明红色填充
          fillOpacity: 0.1
        });
        _this9.map.addOverLay(polygon);
      });
    },
    /**
     * 递归提取 GeoJSON 中所有坐标点
     * 支持 Polygon 和 MultiPolygon 类型
     */
    extractAllCoordinates: function extractAllCoordinates(geojson) {
      var result = [];
      var _extract = function extract(geometry) {
        if (!geometry) return;
        if (geometry.type === 'Polygon') {
          // Polygon: coordinates 是 [外环, 内环1, 内环2, ...]
          // 我们只取外环（索引0）来绘制整体轮廓
          result.push(geometry.coordinates[0]);
        } else if (geometry.type === 'MultiPolygon') {
          // MultiPolygon: coordinates 是 [[外环, 内环...], [外环, 内环...], ...]
          geometry.coordinates.forEach(function (polygon) {
            result.push(polygon[0]); // 只取每个多边形的外环
          });
        } else if (geometry.type === 'GeometryCollection') {
          geometry.geometries.forEach(function (geom) {
            return _extract(geom);
          });
        }
      };

      // 遍历所有 features
      if (geojson.features) {
        geojson.features.forEach(function (feature) {
          _extract(feature.geometry);
        });
      } else {
        _extract(geojson);
      }
      return result;
    }
  }
};